import { getRuntimeEnvVariables } from 'helpers/Utils';

export const TOTAL_RECO_SLIDES = 3;

export function validatePromotionsData (promotions) {
  // eslint-disable-next-line eqeqeq
  const showPromotions = getRuntimeEnvVariables('RUNTIME_ENABLE_DASHBOARD_PROMOTIONS') == 'true';
  const { recommendations } = promotions || { recommendations: [] };

  const promotionsReco = recommendations.slice(0, TOTAL_RECO_SLIDES);
  const displayPromotionsReco = showPromotions && promotionsReco.length >= TOTAL_RECO_SLIDES;

  return displayPromotionsReco ? promotionsReco : null;
}

export default {
  TOTAL_RECO_SLIDES,
  validatePromotionsData,
};
